// = Libs =
import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// = Styles =
// = Imports =
import Page from '@/common/containers/page/page';
import Container from '@/common/containers/container/container';
import Jumbotron from '@/common/components/core/jumbotron/jumbotron';
import { CreatePollForm } from '@/pages/poll/new-poll/new-poll.types';
import { createPoll } from '@/services/poll.service';
import { generateNotification } from '@/helpers/notificationHelper';
import { INITIAL_VALUES } from '@/pages/poll/new-poll/new-poll.constants';
import PollSettings from '@/pages/poll/componens/poll-settings/poll-settings';

const NewPoll: FC = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const history = useHistory();

  const handleSubmit = async (values: CreatePollForm): Promise<void> => {
    const { error, id } = await createPoll(values);

    if (error === '') {
      generateNotification('success', 'Мониторинг успешно создан');
      history.push(`/poll/author/${id}/`);
    } else {
      generateNotification('error', 'Не удалось создать мониторинг');
    }
  };

  return (
    <Page>
      <Jumbotron
        title={'Новый мониторинг'}
        previousPath={`/polls/author/${orgId}/`}
        previousPage="Мониторинги данных"
      />
      <Container>
        <PollSettings
          initialValues={{ ...INITIAL_VALUES, author: Number(orgId) }}
          orgId={Number(orgId)}
          handleSubmit={handleSubmit}
        />
      </Container>
    </Page>
  );
};

export default NewPoll;
